<template>
	<div class="branch-container">
		<div class="small-title">
			<div>日报管理</div>
		</div>
		<!-- title end -->
		<div class="daily-content">
			<div class="daily-table" v-if="showTable">
				<div class="">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane
							v-for="(item, index) in tabsList"
							:key="index"
							:label="item.name"
							:name="item.name"
						></el-tab-pane>
					</el-tabs>
				</div>
				<div class="table-complex">
					<div class="table-operate">
						<div class="search-shelf">
							<div class="date">
								日期：
								<el-date-picker
									class="date-picker"
									v-model="changeDate"
									:picker-options="pickerOptions"
									type="daterange"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									range-separator="-"
									start-placeholder="开始时间"
									end-placeholder="结束时间"
									@change="changeTime"
								>
								</el-date-picker>
							</div>
							<div class="search">
								<span>人员姓名：</span>
								<el-select
									v-infinite-scroll="loadingUserList"
									:infinite-scroll-disabled="!user_allPage ? 'disabled' : ''"
									:infinite-scroll-immediate="false"
									v-model="personnelName"
									placeholder="请选择"
									filterable
									clearable
									@change="selectUser"
								>
									<el-option
										v-for="item in personnelList"
										:key="item.id"
										:label="item.real_name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<el-button @click="filterSearchData" size="medium" class="wanna-design"
									>查询</el-button
								>
							</div>
						</div>
						<div class="create-btn">
							<el-button
								size="medium"
								class="wanna-design create"
								@click="onBindCreateDaily('create')"
								>创建日报</el-button
							>
						</div>
					</div>
					<div class="table-content">
						<el-table v-if="tableList.length > 0" :data="tableList" label-class-name="column-title">
							<el-table-column
								v-for="(item, index) in tableTitleList"
								:key="index"
								:prop="item"
								:label="tableTitle[item]"
								:resizable="false"
							>
							</el-table-column>
							<el-table-column label="操作" align="right">
								<template slot-scope="scope">
									<el-button
										class="text-button"
										v-for="(item, index) in operationAuthority[tabsNameId.indexOf(activeName)]"
										v-if="item.name != '编辑' || checkEditTime(scope.row.base_create_time)"
										:key="index"
										type="text"
										size="small"
									>
										<span @click="item.eventBind(scope.row)">
											{{ item.name }}
										</span>
									</el-button>
								</template>
							</el-table-column>
						</el-table>

						<div class="class-card" v-else>
							<span class="empty">暂无数据</span>
						</div>
					</div>
				</div>
				<div class="daily-page" v-if="tableList.length > 0">
					<el-pagination
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="page"
						:page-sizes="[10, 20]"
						:page-size="rows"
						layout="prev, pager, next, sizes, jumper,slot"
						:total="total.total"
					>
					</el-pagination>
				</div>
			</div>
		</div>
		<el-drawer
			title="日报详情"
			custom-class="drawer-width"
			:with-header="false"
			:visible.sync="drawer"
			:direction="direction"
			:before-close="handleCloseDetail"
			size="41%"
		>
			<div class="content-drawer">
				<div class="title-drawer">
					<div class="title-text">日报详情</div>
					<div class="close-title-drawer" @click="drawer = false">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<div class="detail-drawer">
					<div class="personal-shelf">
						<div class="name">
							{{ details.real_name }}
							<span v-if="details.user_bu_meng">{{ details.user_bu_meng }}</span>
						</div>
						<div class="create-time"> 创建时间：{{ details.base_create_time }} </div>
					</div>
					<div class="detail-shelf">
						<div class="detail-info-item">
							<div class="label">日报时间:</div>
							<div class="value">
								{{ details.user_dome_time }}
							</div>
						</div>
						<div class="detail-info-item">
							<div class="label">日报内容:</div>
							<div class="value">
								{{ details.user_pro_name }}
							</div>
						</div>
						<div class="detail-info-item">
							<div class="label">所需资源或难点:</div>
							<div class="value">
								{{ details.user_require }}
							</div>
						</div>
						<div class="detail-info-item">
							<div class="label">关联订单:</div>
							<div class="value">
								<span v-for="(item, index) in details.user_order_id" :key="item.d"
									>{{ item.order_pro_name
									}}<span v-show="index != 0 && index != details.user_order_id.length - 1"
										>/</span
									></span
								>
							</div>
						</div>
						<div class="detail-info-item">
							<div class="label">同步相关人员:</div>
							<div class="value person">
								<el-tooltip
									class="item"
									v-for="(item, index) in details.related_user_id"
									:key="item.id"
									effect="dark"
									:content="item.real_name"
									placement="top-start"
								>
									<div class="related-person">
										<img
											class="avatar"
											v-if="item.user_head_img"
											:src="item.user_head_img"
											alt=""
										/>
										<img
											class="avatar"
											v-else
											src="@/assets/imgs/img/touxiang@2x.ada3ecfa.png"
											alt=""
										/>
										<span>{{ item.real_name }}</span>
									</div>
								</el-tooltip>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import {
		$dailyUserDailyList,
		$dailyUserNameList,
		// $dailyUserDailyAdd,
		// $dailyUserList,
		$dailyUserDailyDetail,
		// $dailyUserDailyEdit,
	} from '@/api';
	export default {
		components: {},
		computed: {},
		watch: {},
		data() {
			return {
				details: {},
				drawer: false,
				direction: 'rtl',
				tableTitle: {
					// 表头
					user_dome_time: '日报时间',
					user_pro_name: '	工作内容',
					related_user_name: '	同步相关人名称',
					user_order_name: '关联订单',
					user_bu_meng: '区域',
					base_creator_name: '	创建人姓名',
					user_require: '资源需求',
				},
				tableTitleList: [],
				// 日报管理 权限
				permissions: {},
				activeName: '', // 当前标签名
				showTable: false, // 显示 表格
				tabsList: [], // 标签头 列表
				// 标签头id
				tabsNameId: ['我的日报', '部门日报', '关联我的'],
				timeDate: {
					start_time: '',
					end_time: '',
				}, // 时间
				changeDate: [], //选择时间
				personnelName: '', // 人员名称
				personnelList: [], // 人员名称列表
				page: 1,
				rows: 10,
				total: 0,
				tableList: [],
				user_page: 1,
				user_rows: 200,
				user_allPage: true,
				// 我的日报 、部门日报 、关联我的
				operationAuthority: [
					[
						{
							name: '编辑',
							eventBind: (ev) => {
								// console.log("编辑");
								return this.editDailyInfo(ev);
							},
						},
						{
							name: '详情',
							eventBind: (ev) => {
								// console.log("详情");
								return this.checkDailyInfo(ev);
							},
						},
					],
					[
						{
							name: '详情',
							eventBind: (ev) => {
								// console.log("详情");
								return this.checkDailyInfo(ev);
							},
						},
					],
					[
						{
							name: '详情',
							eventBind: (ev) => {
								// console.log("详情");
								return this.checkDailyInfo(ev);
							},
						},
					],
				],
				pickerOptions: {
					disabledDate(time) {
						//只能选择今天及今天之前的日期
						return time.getTime() > Date.now();
						//只能选择今天及今天之后的日期
						//return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后的日期，今天的日期也不能选
					},
				},
			};
		},
		beforeCreate() {},
		created() {
			this.getTagPermissions();
			this.getUsersList();
		},
		beforeMount() {},
		mounted() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		methods: {
			/**
			 * 更改查询时间
			 * @param {*} ev
			 */
			changeTime(ev) {
				if (!ev) {
					this.timeDate = {
						start_time: '',
						end_time: '',
					};
					return;
				}
				// console.log(ev);
				let time1 = ev[0], // 后端传参 时间格式
					// date1 = ev[0].getTime(), // 时间戳
					time2 = ev[1];
				// date2 = ev[1].getTime();
				this.timeDate = {
					start_time: time1,
					end_time: time2,
				};
				this.date_range = `${time1}~${time2}`;
			},
			handleClick() {
				this.getList();
			},
			// 关闭 详情 抽屉
			handleCloseDetail(done) {
				done();
			},
			// 获取 权限
			getTagPermissions() {
				// 获取 用户展示内容权限
				this.$data.permissions = this.$store.state.personalCenterPermissions.find(function check(
					val
				) {
					return val.name === '日报管理';
				});
				// console.log(this.$data.permissions);
				// 标签页 标头
				this.tabsList = this.permissions.children;
				// 请求 用的标签页id
				this.tabsList = this.tabsList.map((item) => {
					item.request_id = this.tabsNameId.indexOf(item.name);
					return item;
				});
				this.activeName = this.tabsList[0].name;
				this.showTable = true;
				this.getList();
			},
			filterSearchData() {
				// if (!String(this.personnelName).trim()) return; // 输入框为空 直接返回

				this.getList();
			},
			// 获取数据
			getList() {
				let { page, rows, activeName, tabsNameId, personnelName, timeDate } = this.$data;

				let data = {
					page,
					rows,
					type: tabsNameId.indexOf(activeName),
				};
				if (personnelName) {
					data.user_ids = personnelName;
				}
				if (timeDate.start_time && timeDate.end_time) {
					data.start_time = timeDate.start_time;
					data.end_time = timeDate.end_time;
				}
				$dailyUserDailyList(data).then((res) => {
					if (res) {
						this.tableList = res.data.rows;
						this.total = res.data.total;
						this.tableTitleList = [];
						Object.keys(res.data.title).forEach((item) => {
							if (this.tableTitle[item]) {
								this.tableTitleList.push(item);
							}
						});
					}
				});
			},
			// 加载 用户列表
			loadingUserList() {
				console.log('1');
				if (this.user_allPage) {
					this.user_page++;
					this.getUsersList();
				}
			},
			// 获取用户列表
			getUsersList() {
				let { user_page, user_rows } = this.$data;
				$dailyUserNameList({
					page: user_page,
					limit: user_rows,
				}).then((res) => {
					if (res) {
						if (res.data.length < user_rows) {
							this.user_allPage = false;
						}
						this.personnelList.push(...res.data);
					}
				});
			},
			/**
			 *  修改当前 显示个数
			 */
			handleSizeChange(ev) {
				this.rows = ev;
				this.getList();
			},
			/**
			 *  切换 页码
			 * @param {*} ev
			 */
			handleCurrentChange(ev) {
				this.page = ev;
				this.getList();
			},
			/**
			 *  查看 日报
			 * @param {*} ev
			 */
			checkDailyInfo(ev) {
				// console.log(ev);
				this.drawer = true;
				$dailyUserDailyDetail({
					id: ev.id,
				}).then((res) => {
					this.details = res.data;
				});
			},
			/**
			 * 编辑日报
			 */
			editDailyInfo(ev) {
				this.$router.push({
					path: '/dailycreate',
					query: {
						post_name: 'edit',
						id: ev.id,
					},
				});
			},
			selectUser(ev) {
				// console.log(ev);

				// 输入框为空 重新获取全部数据
				let timer;
				if (ev.length == 0) {
					timer = setTimeout(() => {
						this.getList();
					}, 300);
				} else {
					if (timer) {
						clearTimeout(timer);
					}
				}
			},
			onBindCreateDaily(name) {
				this.$router.push({
					path: '/dailycreate',
					query: {
						post_name: name,
					},
				});
			},
			// 是否可编辑
			checkEditTime(time) {
				let sevenDay = 3600 * 24 * 7 * 1000;
				let c_time = new Date(time).getTime();
				let t_time = new Date().getTime();
				if (t_time >= c_time && c_time >= t_time - sevenDay) {
					return true;
				} else {
					return false;
				}
			},
		},
	};
	Date.prototype.Format = function (fmt) {
		// author: meizz

		var o = {
			'M+': this.getMonth() + 1, // 月份

			'd+': this.getDate(), // 日

			'h+': this.getHours(), // 小时

			'm+': this.getMinutes(), // 分

			's+': this.getSeconds(), // 秒

			'q+': Math.floor((this.getMonth() + 3) / 3), // 季度

			S: this.getMilliseconds(), // 毫秒
		};

		if (/(y+)/.test(fmt))
			fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));

		for (var k in o)
			if (new RegExp('(' + k + ')').test(fmt))
				fmt = fmt.replace(
					RegExp.$1,
					RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
				);

		return fmt;
	};
</script>

<style lang="scss" scoped>
	.small-title {
		box-sizing: border-box;
		padding: 18px 20px;
		font-size: 20px;
		font-weight: bold;
		line-height: 1;
		color: rgba(0, 0, 0, 1);
		background: rgba(255, 255, 255, 1);
	}
	.daily-content {
		position: relative;
		box-sizing: border-box;
		padding: calc(var(--proportion) * 24px);
		padding-bottom: 0px;
		width: 100%;

		.daily-table {
			position: relative;
			padding-bottom: 40px;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			width: 100%;
			min-height: 600px;
			background: rgba(255, 255, 255, 1);
			border-radius: 2px;

			::v-deep .el-tabs__item {
				padding: 0px 20px;
			}
		}
		.table-complex {
			padding: calc(var(--proportion) * 4px) calc(var(--proportion) * 24px);
		}
		.table-operate {
			margin-bottom: 10px;
			.search-shelf {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				.date {
					font-size: 14px;

					font-weight: 400;
					line-height: 22px;
					color: #333333;
					.date-picker {
						margin: 0px 40px 0px 5px;
					}
				}
				.search {
					display: flex;
					align-items: center;
					span {
						margin-right: 10px;
						font-size: 14px;
						font-weight: 400;
						line-height: 22px;
						color: #333333;
					}
				}
			}
		}
		.wanna-design.create {
			margin-left: 0px;
			margin-top: 16px;
		}
		.wanna-design {
			margin-left: 14px;
			height: 40px;
			background-color: rgba(230, 50, 65, 1);
			color: #fff;
		}
		.table-content ::v-deep th {
			background: rgba(250, 250, 250, 1);
			color: #333333;
			font-weight: 400;
		}
		.daily-page {
			position: absolute;
			bottom: -4px;
			right: 18px;
			box-sizing: border-box;
			padding: 0px 24px 0px 0px;
			display: flex;
			justify-content: right;
		}
	}
	::v-deep .content-drawer {
	}
	::v-deep .title-drawer {
		position: relative;
		box-sizing: border-box;
		padding: 0px 32px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 54px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 0px #e9e9e9;

		font-weight: bold;
		.title-text {
			font-size: 16px;
		}
		.close-title-drawer {
			cursor: pointer;
			width: 0.5rem;
			height: 0.5rem;
			display: flex;
			i {
				font-size: 0.5rem;
				font-weight: 600;
			}
		}
	}
	.detail-drawer {
		box-sizing: border-box;
		padding: 20px 28px;

		.personal-shelf {
			font-size: 20px;

			font-weight: bold;
			color: #333333;
			.name {
				display: flex;
				align-items: center;
				max-width: 80%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				span {
					margin-left: 6px;
					box-sizing: border-box;
					display: inline-block;
					padding: 2px 6px;
					padding-bottom: 3px;
					border-radius: 2px;
					max-width: 150px;
					overflow: hidden;
					text-align: center;
					text-overflow: ellipsis;
					white-space: nowrap;
					font-size: 12px;
					font-weight: 400;
					color: #e60000;
					background: rgba(230, 50, 65, 0.2);
				}
			}
			.create-time {
				margin-top: 6px;
				font-size: 16px;

				font-weight: 400;
				color: #999999;
			}
		}
		.detail-shelf {
			margin-top: 20px;
			.detail-info-item {
				margin-bottom: 16px;
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;

				.label {
					margin-right: 12px;
					flex-shrink: 0;
					display: flex;
					width: 128px;
					font-size: 16px;
					font-weight: bold;
					color: #333333;
				}
				.value.person {
					display: flex;
					flex-wrap: wrap;
				}
				.value {
					font-size: 16px;
					font-weight: 400;
					width: 80%;
					color: #333333;
					word-break: break-all;
				}
			}
			.related-person {
				margin-bottom: 10px;
				margin-right: 18px;
				display: flex;
				align-items: center;
				img {
					margin-right: 4px;
					width: 24px;
					height: 24px;
					border-radius: 50%;
				}
				span {
					max-width: 100px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					font-size: 16px;
					line-height: 20px;
					height: 20px;
					font-weight: 400;
					color: #333333;
				}
			}
		}
	}
	.text-button {
		color: #e60000;
	}
</style>
<style lang="scss" scoped>
	// 分页 颜色
	::v-deep {
		.el-pagination.is-background .el-pager li:not(.disabled) {
			background-color: #fff; // 进行修改未选中背景和字体
			border: 1px solid #d9d9d9;
			color: rgba(0, 0, 0, 0.65);
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #e60000 !important; // 进行修改选中项背景和字体
			color: #ffffff;
		}
		.btn-prev,
		.btn-next {
			border: 1px solid #d9d9d9;
			background-color: #fff !important;
		}

		// 数字
		.el-pagination.is-background .el-pager li {
			font-weight: 400;
		}

		// 每页条数框
		.el-select .el-input.is-focus .el-input__inner {
			border-color: $theme-color;
			border-radius: 4px;
		}
		.el-pagination__sizes .el-input .el-input__inner:hover {
			border-color: $theme-color;
		}
		.el-input__inner:focus {
			border-color: $theme-color;
		}

		// 日期输入框
		.el-range-editor.is-active,
		.el-range-editor.is-active:hover {
			border-color: $theme-color;
		}
	}

	.class-card {
		width: 100%;
		.empty {
			width: 100%;
			display: block;
			padding-top: 50px;
			box-sizing: border-box;
			text-align: center;
			font-size: 16px;
			font-weight: 400;
			color: #999999;
		}
	}
	.search {
		display: flex;
	}
</style>
